const zh = {
  'home.eyebrow':         '🌍 geoplay24.com',
  'home.title':           'Geo Play 24',
  'home.subtitle.line1':  '7 款沉浸式地理游戏。',
  'home.subtitle.line2':  '一个地球。五个等级。无尽惊喜。',
  'home.tagline.line1':   '七款游戏,一颗星球。',
  'home.tagline.line2':   '发现地球的每个角落 —— 竞争、得分、征服你的帝国。',
  'home.footer.company':  '公司',
  'home.footer.legal':    '法律',
  'home.footer.about':    '关于我们',
  'home.footer.contact':  '联系',
  'home.footer.github':   'GitHub',
  'home.footer.tiktok':   'TikTok',
  'home.footer.x':        'X / Twitter',
  'home.footer.privacy':  '隐私',
  'home.footer.terms':    '条款',
  'home.footer.cookies':  'Cookie',
  'home.copy':            'powered by: © 2026 Janek @ DevFlow C ™️',
  'home.beta.title':      '加入我们 Android 应用的早期测试者',
  'home.beta.text':       '获得 Founder 徽章、终身 Premium,以及上方抽奖奖品的机会。',
  'home.beta.cta':        'BETA 计划',

  'common.start':         '开始',
  'common.startBig':      '▶ 开始',
  'common.back':          '返回',
  'common.home':          '首页',
  'common.howToPlay':     '玩法',
  'common.gotIt':         '明白了 — 回到游戏',
  'common.next':          '下一关',
  'common.restart':       '重新开始',
  'common.tryAgain':      '再试一次',
  'common.playAgain':     '再玩一次',
  'common.mainMenu':      '主菜单',
  'common.quit':          '退出',
  'common.play':          '开玩',
  'common.unlock':        '🔒 用 Premium 解锁',
  'common.language':      '语言',

  'rules.kicker.goal':         '目标',
  'rules.kicker.howToPlay':    '玩法',
  'rules.kicker.levels':       '等级',
  'rules.kicker.tips':         '小贴士',
  'rules.gameNotFound':        '未找到游戏',
  'rules.points':              '分',

  'games.origin.title':       'Origin Hunt',
  'games.origin.tagline':     '寻根之旅',
  'games.origin.description': '世界上某个随机街景位置。在地图上指出你在哪里。5 关精度从 100 公里到 1 公里。',
  'games.hunt.title':         'Object Hunt',
  'games.hunt.tagline':       'GPS 寻宝',
  'games.hunt.description':   '空降在真实地标附近。在街景中走过去找它。等级越高,指南针越没用。',
  'games.photo.title':        'Photo Detective',
  'games.photo.tagline':      '解读线索',
  'games.photo.description':  '一张静态街景图 —— 不能转动,不能移动。读路牌、植物、太阳方向。从 30 秒到 5 秒一闪。',
  'games.pangaea.title':      'Pangaea Puzzle',
  'games.pangaea.tagline':    '重组地球',
  'games.pangaea.description':'大陆和岛屿漂浮在 3D 地球周围。把它们拖回原位 —— 现代位置,或古代盘古大陆。',

  'rules.origin.goal': '你被空投到地球上一个随机街景中。请在世界地图上尽可能精确地标出自己。',
  'rules.origin.step1': '环顾全景。读路牌、数车道、看天上的太阳方向。',
  'rules.origin.step2': '点击小地图,在你认为所在的位置放置图钉。',
  'rules.origin.step3': '提交。图钉离真实位置越近,得分越高。',
  'rules.origin.step4': '等级连环 —— 通过距离阈值才能解锁下一关。',
  'rules.origin.level1': '100 公里以内',
  'rules.origin.level2': '50 公里以内',
  'rules.origin.level3': '25 公里以内',
  'rules.origin.level4': '10 公里以内',
  'rules.origin.level5': '1 公里以内',
  'rules.origin.tip1': '行驶方向、车牌格式、道路标线颜色能很快暴露国家。',
  'rules.origin.tip2': '植被 + 太阳高度可缩小纬度范围。路牌可锁定城市。',
  'rules.origin.tip3': 'Master Geographer(L5 = 1 公里)非常残酷 —— 大多数玩家止步 L3 或 L4。',

  'rules.hunt.goal': '街景中你被放在一个真实地标附近。在全景中走过去,直到站在它上面。等级越高,指南针越无用。',
  'rules.hunt.step1': '在顶部栏读出目标名称。',
  'rules.hunt.step2': '用指南针箭头 + 距离指示来对准方向。',
  'rules.hunt.step3': '点击街景中的箭头前进。',
  'rules.hunt.step4': '进入发现区后,「找到了!」按钮激活 —— 按下得分。',
  'rules.hunt.level1': '5 公里 · 10 分钟 · 世界知名 · 箭头+精确距离 · 100 米发现区',
  'rules.hunt.level2': '15 公里 · 12 分钟 · 世界知名 · 箭头+大致距离',
  'rules.hunt.level3': '25 公里 · 12 分钟 · 全国知名 · 仅指南针,无距离',
  'rules.hunt.level4': '50 公里 · 15 分钟 · 全国知名 · 冷热提示',
  'rules.hunt.level5': '50 公里 · 10 分钟 · 冷门 · 仅 POI 名称,无 GPS',
  'rules.hunt.tip1': 'L4–L5 你有 3 次 Compass Ping —— 箭头闪现,谨慎使用。',
  'rules.hunt.tip2': '中点奖励:走过半路 +2 分钟。',
  'rules.hunt.tip3': '只有名称时,凭记忆或观察周围 —— 许多地标从远处也能辨认。',

  'rules.photo.goal': '一张静态街景画面 —— 不能转动,不能移动。从路牌、植物、太阳方向、道路标线推断地球上的位置。',
  'rules.photo.step1': '先选一个区域(世界、欧洲、亚洲等)—— 这决定了搜索范围。',
  'rules.photo.step2': '照片在固定的观察时间内闪现。每一秒都要利用。',
  'rules.photo.step3': '计时结束后出现地图。下你最好的赌注。',
  'rules.photo.step4': '越近 = 越多分。结果画面会重放照片,让你看清错过了什么。',
  'rules.photo.level1': '30 秒观察 · 精度 1 000 公里',
  'rules.photo.level2': '20 秒 · 500 公里',
  'rules.photo.level3': '15 秒 · 250 公里',
  'rules.photo.level4': '10 秒 · 100 公里',
  'rules.photo.level5': '5 秒一闪 · 50 公里',
  'rules.photo.tip1': '路牌上的语言是最快的线索。一个词往往就能锁定国家。',
  'rules.photo.tip2': '太阳方向告诉你哪边是南(北半球)或北(南半球)。',
  'rules.photo.tip3': '电线杆形状、道路标线、车牌都出乎意料地有诊断力。',

  'rules.pangaea.goal': '3D 地球,六块大陆。把每一块放在该等级的角度容差内 —— 现代位置,或 3 亿年前盘古大陆中的位置。',
  'rules.pangaea.step1': '从右侧列表选一块大陆。',
  'rules.pangaea.step2': '在地球上点击你认为该放的位置。',
  'rules.pangaea.step3': '在容差内 → 自动吸附。否则 → 红色反馈,重试。',
  'rules.pangaea.step4': '每块大陆 3 次机会。至少 6 中 5 才能晋级。',
  'rules.pangaea.level1': '大陆 · 现代 · 容差 25°',
  'rules.pangaea.level2': '现代 · 容差 18°',
  'rules.pangaea.level3': '现代 · 12° 精确',
  'rules.pangaea.level4': '盘古 · 古代 · 容差 25°',
  'rules.pangaea.level5': '盘古 · 古代 · 18° 精确',
  'rules.pangaea.tip1': '拖动地球旋转。滚轮缩放。',
  'rules.pangaea.tip2': '盘古时代,大陆都聚集在南半球 —— 非洲和南美洲拼合,印度紧贴东非,北美洲挨着欧洲。',
  'rules.pangaea.tip3': '南极洲当时大约在赤道附近,澳大利亚从下面紧挨着它。',

  /* ─── Landmark Quiz ─── */
  'games.landmark.title':          'Landmark Quiz',
  'games.landmark.tagline':        '认出地标',
  'games.landmark.description':    '一张著名建筑或纪念碑的照片 — 认出来,在世界地图上插针。永久免费。',
  'rules.landmark.goal':           '看到一张著名地标的照片。在世界地图上,凭你认知插上针。',
  'rules.landmark.step1':          '看几秒钟照片。认出建筑、读懂背景。',
  'rules.landmark.step2':          '计时器结束后地图出现。',
  'rules.landmark.step3':          '插针并提交。越近,分数越高。',
  'rules.landmark.step4':          '5 级。每一级时间更短、要求更严。',
  'rules.landmark.level1':         '30 秒观察 · 精度 1 000 公里',
  'rules.landmark.level2':         '20 秒 · 500 公里',
  'rules.landmark.level3':         '15 秒 · 250 公里',
  'rules.landmark.level4':         '10 秒 · 100 公里',
  'rules.landmark.level5':         '5 秒一闪 · 50 公里',
  'rules.landmark.tip1':           '标志性外形(埃菲尔、金字塔)一眼就认 — 分数来自精准插针。',
  'rules.landmark.tip2':           '不太出名的地标:读背景 — 气候、建筑风格、周围。',
  'rules.landmark.tip3':           '图片来自维基百科 CC-BY-SA 协议。点击署名查看来源。',

  'paywall.title':        "这是 Premium 游戏",
  'paywall.text':         "用你在游戏中赚取的积分解锁这款游戏。",
  'paywall.cta':          "加入 BETA 计划",
  'paywall.dismiss':      "稍后再说",

  /* ─── Spot the Landmark ─── */
  'games.spot.title':       "Spot the Landmark",
  'games.spot.tagline':     "多选题",
  'games.spot.description': "一张著名建筑或纪念碑的照片 — 在 3-6 个选项中选择正确答案。无尽模式,每轮更难。永久免费。",

  'rules.spot.goal':   "看图选出正确的地标。一次错误就结束本轮。",
  'rules.spot.step1':  "选择区域(世界、欧洲、亚洲…) — 题库按大陆筛选。",
  'rules.spot.step2':  "一张著名地标照片连同问题出现。",
  'rules.spot.step3':  "从选项中点击正确答案。",
  'rules.spot.step4':  "保持连胜 — 每升一级多一个选项(上限 6),也更难。",
  'rules.spot.level1': "L1–L3 · 3-5 选项 · 仅名称",
  'rules.spot.level2': "L4+ · 6 选项 · 仅名称",
  'rules.spot.level3': "L10+ · 6 选项 · 名称+国家",
  'rules.spot.level4': "L20+ · 6 选项 · 名称+城市+国家",
  'rules.spot.level5': "无尽 · 分数随深度增长 · 错一题就结束",
  'rules.spot.tip1':   "干扰项来自同一大陆 — 仔细看。",
  'rules.spot.tip2':   "标志性形状(埃菲尔、金字塔)很轻松 — 分数靠深度。",
  'rules.spot.tip3':   "L10 起加上国家;L20 起加上城市。",

  "spot.region.title": "想在哪里玩?",
  "spot.region.sub": "选一个区域。著名地标会出现 — 选出正确答案以继续。",
  "spot.q.name": "这是什么地标?",
  "spot.q.namecountry": "名称 + 国家?",
  "spot.q.namecity": "名称 + 城市 + 国家?",
  "spot.score": "分数",
  "spot.choices": "选项",
  "spot.correct": "正确",
  "spot.wrong": "错误",
  "spot.points": "分",
  "spot.runTotal": "本轮合计",
  "spot.next": "下一题 →",
  "spot.youPicked": "你选了",
  "spot.finalScore": "最终分数",
  "spot.reachedLevel": "到达等级",
  "spot.tryAgain": "再来一次 ↺",
  "spot.changeRegion": "更换区域",
  "spot.mainMenu": "主菜单",

  /* ─── Auth ─── */
  "auth.signIn": "登录",
  "auth.eyebrow": "MINDFUL ZEN WORLD",
  "auth.title": "登录或创建账户",
  "auth.subtitle": "无需密码 — 我们会用邮件发送魔法链接。新用户?账户自动创建。",
  "auth.send": "发送魔法链接",
  "auth.sending": "发送中…",
  "auth.invalidEmail": "请输入有效的邮箱。",
  "auth.sendFailed": "链接发送失败,请重试。",
  "auth.checkInbox": "查看你的邮箱",
  "auth.linkSentTo": "登录链接已发往:",
  "auth.spamHint": "没找到?查看垃圾邮件。链接 1 小时后失效。",
  "auth.gotIt": "好的",
  "auth.fineprint": "继续即表示同意我们的条款和隐私政策。",
  "auth.menu.profile": "我的资料",
  "auth.menu.admin": "管理",
  "auth.menu.signOut": "退出",
  "auth.callback.signingIn": "正在登录…",
  "auth.callback.hold": "稍等。",
  "auth.callback.welcome": "欢迎",
  "auth.callback.redirecting": "带你回到游戏…",
  "auth.callback.problem": "出现了问题",

  /* ─── Auth ─── */

  /* ─── Profile ─── */
  "profile.title": "我的资料",
  "profile.totalPoints": "总分",
  "profile.totalRuns": "已玩局数",
  "profile.gamesPlayed": "尝试的游戏",
  "profile.editTitle": "编辑资料",
  "profile.displayName": "显示名称",
  "profile.avatar": "头像",
  "profile.country": "国家(可选)",
  "profile.countryHint": "两位 ISO 国家代码,如 CN、US、JP。用于排行榜国旗。",
  "profile.save": "保存",
  "profile.saving": "保存中…",
  "profile.saved": "已保存",
  "profile.nameTooShort": "显示名称至少2个字符。",
  "profile.perGame": "各游戏最佳",
  "profile.noRuns": "还没有玩过 — 回到菜单选一个游戏吧。",

  /* ─── Profile ─── */

  /* ─── Gating + Anon limit ─── */
  "common.locked": "已锁定",
  "common.needPoints": "需 {n} 分",
  "locked.pill": "已锁定",
  "locked.title": "{game} 已锁定",
  "locked.text": "距离解锁 {game} 还差 {remaining} 分。继续玩可用的游戏即可累积。",
  "locked.dismiss": "知道了",
  "spot.anon.playsLeft": "还剩 {n} 次免费游戏 — 登录以继续。",
  "spot.anon.title": "免费游戏已用完",
  "spot.anon.text": "你已玩了 {used}/{limit} 次免费游戏。登录以继续 — 免费,无需密码,只需邮件魔法链接。",
  "spot.anon.signIn": "登录继续 →",
  "spot.anon.back": "返回菜单",

  /* ─── Gating + Anon limit ─── */

  /* ─── Next game banner ─── */
  "rules.next.upcoming": "下一关",
  "rules.next.unlocked": "下一关 — 已解锁",
  "rules.next.unlockedHint": "你的分数够了 — 回菜单开玩吧。",
  "rules.next.needMore": "解锁还差 {remaining} 分 — 继续玩这个游戏赚分。",
  "rules.next.signedOut": "攒到 {threshold} 分即可解锁 — 登录开始计分。",
  "rules.next.premiumHint": "Premium 解锁 — 随 Android Beta 上线。",

  /* ─── Next game banner ─── */

  /* ─── Audio Atlas ─── */
  'games.audio.title':       "Audio Atlas",
  'games.audio.tagline':     "国旗 + 国歌",
  'games.audio.description': "播放一首国歌,同时显示该国国旗。在地图上把图钉插在首都。",

  'rules.audio.goal':   "你听到一首国歌,看到该国国旗。在世界地图上尽量准确地把图钉插在首都。",
  'rules.audio.step1':  "选择区域。题库按大陆过滤。",
  'rules.audio.step2':  "国歌自动播放。国旗一直显示。",
  'rules.audio.step3':  "计时归零时地图出现。把图钉插在首都。",
  'rules.audio.step4':  "在距离阈值内通过。级别越高聆听越短。",
  'rules.audio.level1': "10 秒 · 1,000 公里内",
  'rules.audio.level2': "8 秒 · 500 公里",
  'rules.audio.level3': "6 秒 · 250 公里",
  'rules.audio.level4': "4 秒 · 100 公里",
  'rules.audio.level5': "3 秒一闪 · 50 公里",
  'rules.audio.tip1':   "认旗容易 —— 把首都钉得精确才是真正的挑战。",
  'rules.audio.tip2':   "有些首都并非最大城市(巴西利亚、堪培拉、渥太华、比勒陀利亚)。",
  'rules.audio.tip3':   "国歌的节奏和乐器编排也能帮上忙。",

  "audio.region.title": "想在哪里听?",
  "audio.region.sub": "选择一个区域。你会听到国歌并看到该国国旗 —— 在地图上把图钉插在首都。",
  "audio.empty.title": "暂无音频片段",
  "audio.empty.text": "暂无可用的国歌 —— 我们正在整理曲库。请稍后再来,识别新的国家。",
  "audio.listen.hint": "认得国旗和国歌?在地图上把图钉插在首都。",
  "audio.listen.skip": "我听够了 →",
  "audio.submit.ready": "提交 →",
  "audio.submit.empty": "点击地图放置图钉",
  "audio.changeRegion": "更换区域",

  /* ─── Empire ─── */
  "profile.empire.title": "我的帝国",
  "profile.empire.empty": "在 Audio Atlas 或 Landmark Quiz 中识别一个国家即可占领。每答对一题,帝国扩张。",

  /* ─── Empire ─── */

  /* ─── Boost / Shop ─── */
  "boost.title": "跳过磨练",
  "boost.tagline": "购买积分,更快解锁",
  "boost.description": "不想等待?三档套餐起价 €2.99。积分立即到账,所有解锁都算数。",
  "boost.cta": "购买积分",
  "shop.title": "积分商店",
  "shop.sub": "跳过磨练",
  "shop.buy": "购买",
  "shop.opening": "打开中…",
  "shop.success": "支付确认 — 积分将在几秒内到账。",
  "shop.cancel": "已取消 — 未产生费用。",
  "shop.fineprint": "Stripe 一次性购买。确认后立即到账。无订阅,无续费。",
  "shop.boost.badge": "热门",
  "shop.power.badge": "最划算",

  /* ─── Boost / Shop ─── */
};

export default zh;
